import { methodGet } from "./methods";
import { API_INFO } from "../constants";

export const getLibrariesApi = async (payload) => {
  return methodGet(API_INFO + 'intranet/libraries/', payload);
};
